export const parseImageUrl = (url) => {
    return process.env.PUBLIC_URL + url;
}
